import { useState } from "react";
import { FormattedMessage } from "react-intl";

/**
 * Zkopíruje text do schránky (Libor 3. 11. 2026): jedna funkce pro celou aplikaci.
 * Clipboard API s fallbackem na dočasný textarea (iOS Safari, starší prohlížeče).
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.style.cssText = "position:fixed;left:-9999px;top:-9999px;opacity:0";
  document.body.appendChild(ta);
  ta.focus();
  ta.setSelectionRange(0, text.length);
  let ok = false;
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      ok = true;
    } else {
      ok = document.execCommand("copy");
    }
  } catch {
    try {
      ok = document.execCommand("copy");
    } catch {
      /* */
    }
  }
  document.body.removeChild(ta);
  return ok;
}

/** Zkráceně: jen doména a začátek cesty. */
function shorten(url: string): string {
  try {
    const u = new URL(url);
    const path = u.pathname.length > 20 ? `${u.pathname.slice(0, 18)}…` : u.pathname;
    return `${u.host}${path}`;
  } catch {
    return url.length > 40 ? `${url.slice(0, 38)}…` : url;
  }
}

const LINK_ICON = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M6.5 9.5l3-3M9 4.5l1.8-1.8a2.12 2.12 0 013 3L12 7.5M7 11.5l-1.8 1.8a2.12 2.12 0 01-3-3L4 8.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

const CHECK_ICON = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M3.5 8.5l3 3 6-7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/**
 * Odkaz ke zkopírování (Libor 3. 11. 2026): tlačítko se zkrácenou URL a ikonou, po kliknutí
 * stav „Zkopírováno" s fajfkou. Jedna komponenta pro sdílení, Moje já i páry.
 */
export function CopyableUrl({ url, testId, copiedId = "sketch.share.copied" }: { url: string; testId?: string; copiedId?: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <button
      type="button"
      className={`copy-url${copied ? " copy-url--copied" : ""}`}
      onClick={() => void copyToClipboard(url).then((ok) => { setCopied(ok); if (ok) setTimeout(() => setCopied(false), 3000); })}
      data-testid={testId}
    >
      {copied ? CHECK_ICON : LINK_ICON}
      <span className="copy-url__text">{copied ? <FormattedMessage id={copiedId} /> : shorten(url)}</span>
    </button>
  );
}
